import { extension } from "mime-types";

import { INPUT_MAX_LENGTH } from "@/constants/Fields";
/**
 * Converts file to base64.
 *
 * @param {File} file A file object.
 * @return Promise<unknown>
 */
export const convertFileToBase64 = (file: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};

export const fileNameIsTooLong = (file: File) => {
  if (!file) return false;
  return file.name.length > INPUT_MAX_LENGTH;
};

export const getFileExtension = (file: File) => {
  if (file?.type === "application/acad") return "dwg";
  if (file?.type === "drawing/x-dwf") return "dwf";
  if (file?.type === "image/x-dwg") return "dwg";
  if (file?.type === "image/x-dxf") return "dxf";
  return extension(file?.type);
};
